import { FC, PropsWithChildren } from "react";

import { LinkProps } from "@mui/material";

import * as Styled from "./styles";

type TLink = { isDisabled?: boolean; href?: string; component?: string; size?: number | string } & PropsWithChildren &
  LinkProps;
export const Link: FC<TLink> = ({
  isDisabled = false,
  href,
  children,
  component,
  onClick,
  size,
  target = "_blank",
  ...restProps
}) => {
  if (component) {
    return (
      <Styled.Link aria-disabled={isDisabled} underline="always" onClick={onClick} size={size} {...restProps}>
        {children}
      </Styled.Link>
    );
  }
  return (
    <Styled.RouterLink to={href} target={target} rel={target === "_blank" ? "noopener noreferrer" : undefined}>
      <Styled.Link aria-disabled={isDisabled} underline="hover" size={size} {...restProps}>
        {children}
      </Styled.Link>
    </Styled.RouterLink>
  );
};
